import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function HomePostOptions() {
  const navigate = useNavigate();
  const [showVerifyModal, setShowVerifyModal] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);

  return (
    <div style={{padding:16}}>
      <div style={{display:'flex', alignItems:'center', gap:8}}>
        <button onClick={() => navigate(-1)} style={{border:'none', background:'transparent', cursor:'pointer', fontSize:24}}>←</button>
        <h2 style={{margin:0}}>Options</h2>
      </div>

      <div style={{marginTop:20, display:'flex', flexDirection:'column', gap:12}}>
        <button onClick={() => setShowVerifyModal(true)} style={{padding:12, background:'#ff4458', color:'#fff', border:'none', borderRadius:8, fontSize:16}}>Report</button>
        <button onClick={() => setShowBlockModal(true)} style={{padding:12, background:'#ff4458', color:'#fff', border:'none', borderRadius:8, fontSize:16}}>Block</button>
      </div>

      {showVerifyModal && (
        <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:3000}} onClick={() => setShowVerifyModal(false)}>
          <div onClick={(e)=>e.stopPropagation()} style={{background:'var(--surface)',color:'var(--text)',padding:20,borderRadius:8,maxWidth:520,width:'90%',position:'relative'}}>
            <button aria-label="Close" onClick={() => setShowVerifyModal(false)} style={{position:'absolute',top:8,right:8,border:'none',background:'transparent',fontSize:20,cursor:'pointer'}}>✕</button>
            <div style={{display:'flex',justifyContent:'flex-start',alignItems:'center',gap:12}}>
              <h3 style={{margin:0}}>Report</h3>
            </div>
            <div style={{marginTop:12,whiteSpace:'pre-wrap',lineHeight:1.5}}>
              <p style={{margin:0}}>Email to <a href="mailto:linkalikes.com@gmail.com?subject=Verify%20my%20account" style={{color:'#2c7be5'}}>linkalikes.com@gmail.com</a> with the <strong>[USERNAME]</strong> of the user to be reported in order to Report this.</p>
              {/* <div style={{color:"yellowgreen", display:"flex", justifyContent:"center", fontWeight:"700"}}>Just click the email link above to report!</div> */}
            </div>
            {/* no bottom close button per request; modal closed via top-right X or outside click */}
          </div>
        </div>
      )}

      {showBlockModal && (
        <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.45)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:3000}} onClick={() => setShowBlockModal(false)}>
          <div onClick={(e)=>e.stopPropagation()} style={{background:'var(--surface)',color:'var(--text)',padding:20,borderRadius:8,maxWidth:520,width:'90%',position:'relative'}}>
            <button aria-label="Close" onClick={() => setShowBlockModal(false)} style={{position:'absolute',top:8,right:8,border:'none',background:'transparent',fontSize:20,cursor:'pointer'}}>✕</button>
            <div style={{display:'flex',justifyContent:'flex-start',alignItems:'center',gap:12}}>
              <h3 style={{margin:0}}>Block</h3>
            </div>
            <div style={{marginTop:12,whiteSpace:'pre-wrap',lineHeight:1.5}}>
              <p style={{margin:0}}>Email to <a href="mailto:linkalikes.com@gmail.com?subject=Verify%20my%20account" style={{color:'#2c7be5'}}>linkalikes.com@gmail.com</a> with the <strong>[USERNAME]</strong> of the user to be blocked in order to Block this.</p>
              {/* <div style={{color:"blue", display:"flex", justifyContent:"center", fontWeight:"700"}}>Just click the email link above to block!</div> */}
              <div style={{color:"yellowgreen", display:"flex", justifyContent:"center", fontWeight:"700"}}>The user will be blocked automatically within 5 minutes!</div>
            </div>
            {/* no bottom close button per request; modal closed via top-right X or outside click */}
          </div>
        </div>
      )}
    </div>
  );
}
